import { render, staticRenderFns } from "./chat_room.vue?vue&type=template&id=23e5c0f4&scoped=true&"
import script from "./chat_room.vue?vue&type=script&lang=js&"
export * from "./chat_room.vue?vue&type=script&lang=js&"
import style0 from "./chat_room.vue?vue&type=style&index=0&id=23e5c0f4&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e5c0f4",
  null
  
)

export default component.exports